import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Megaphone, X } from "lucide-react";
import api from "@/lib/api";

const KEY = "mulankan_dismissed_announcement";

export default function AnnouncementBanner() {
  const [a, setA] = useState(null);
  useEffect(() => {
    const load = () => api.get("/announcement").then(({ data }) => setA(data.announcement)).catch(() => {});
    load();
    window.addEventListener("mulankan:announcement", load);
    return () => window.removeEventListener("mulankan:announcement", load);
  }, []);
  if (!a || localStorage.getItem(KEY) === a.id) return null;
  const close = () => { localStorage.setItem(KEY, a.id); setA(null); };
  const external = a.link_url && !a.link_url.startsWith("/");
  return (
    <div className="flex items-center gap-3 px-5 sm:px-10 lg:px-14 py-2.5 bg-[var(--accent)] text-[#140A03] text-sm" data-testid="announcement-banner">
      <Megaphone size={16} className="shrink-0" />
      <span className="font-semibold" data-testid="announcement-text">{a.message}</span>
      {a.link_url && (external
        ? <a href={a.link_url} target="_blank" rel="noopener noreferrer" data-testid="announcement-link" className="underline underline-offset-2 font-bold whitespace-nowrap">{a.link_label}</a>
        : <Link to={a.link_url} data-testid="announcement-link" className="underline underline-offset-2 font-bold whitespace-nowrap">{a.link_label}</Link>)}
      <button onClick={close} aria-label="Close announcement" data-testid="announcement-close" className="ml-auto shrink-0 rounded-full p-1 hover:bg-black/10 transition-colors"><X size={15} /></button>
    </div>
  );
}
